/* ==========================================================================
   C13 HEALTH - Product page gallery
   Thumb rail · prev/next · counter · hover zoom · swipe · hotspots
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }

  function initGallery() {
    $$('[data-c13-gallery2]').forEach(function (gal) {
      if (gal.dataset.c13Bound) return;
      gal.dataset.c13Bound = '1';

      var stage   = $('.c13-gal2__stage', gal);
      var slides  = $$('.c13-gal2__slide', gal);
      var thumbs  = $$('[data-c13-gal2-thumb]', gal);
      var zoom    = $('.c13-gal2__zoomlayer', gal);
      var caption = $('[data-c13-gal2-caption]', gal);
      var counter = $('[data-c13-gal2-index]', gal);
      var live    = $('[data-c13-gal2-live]', gal);
      var prevBtn = $('[data-c13-gal2-prev]', gal);
      var nextBtn = $('[data-c13-gal2-next]', gal);
      var index   = 0;

      if (!slides.length) return;

      function show(i, announce) {
        index = (i + slides.length) % slides.length;

        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === index ? 'true' : 'false'); });

        var active = slides[index];

        if (counter) counter.textContent = index + 1;
        if (caption) caption.textContent = active.getAttribute('data-ai-caption') || '';
        if (live && announce) live.textContent = 'Image ' + (index + 1) + ' of ' + slides.length;

        if (zoom) {
          var img = active.querySelector('img');
          zoom.style.backgroundImage = img ? 'url(' + (img.getAttribute('data-zoom') || img.currentSrc || img.src) + ')' : '';
        }

        /* keep the active thumbnail in view on the vertical rail */
        var thumb = thumbs[index];
        if (thumb && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });

        /* brief analysis flourish on change */
        if (!RM.matches) {
          gal.classList.add('is-analysing');
          clearTimeout(gal._scanTimer);
          gal._scanTimer = setTimeout(function () { gal.classList.remove('is-analysing'); }, 850);
        }
      }

      thumbs.forEach(function (t, i) { on(t, 'click', function () { show(i, true); }); });
      on(prevBtn, 'click', function () { show(index - 1, true); });
      on(nextBtn, 'click', function () { show(index + 1, true); });

      on(gal, 'keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); show(index - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1, true); }
      });

      /* hover zoom, pointer devices only */
      if (zoom && stage && window.matchMedia('(hover: hover)').matches) {
        on(stage, 'mousemove', function (e) {
          var r = stage.getBoundingClientRect();
          zoom.style.backgroundPosition =
            (((e.clientX - r.left) / r.width) * 100) + '% ' +
            (((e.clientY - r.top) / r.height) * 100) + '%';
        });
        var zbtn = $('[data-c13-gal2-zoom]', gal);
        on(zbtn, 'click', function () {
          var active = stage.classList.toggle('is-zooming');
          zbtn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      /* touch swipe */
      var sx = 0, sy = 0, moved = false;
      on(stage, 'touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false; }, { passive: true });
      on(stage, 'touchmove', function (e) { if (Math.abs(e.touches[0].clientX - sx) > 12) moved = true; }, { passive: true });
      on(stage, 'touchend', function (e) {
        if (!moved) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1), true);
      }, { passive: true });

      /* hotspots */
      $$('[data-c13-hotspot]', gal).forEach(function (h) {
        on(h, 'click', function (e) {
          e.stopPropagation();
          var open = h.getAttribute('aria-expanded') === 'true';
          $$('[data-c13-hotspot]', gal).forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
          h.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
      on(document, 'click', function () {
        $$('[data-c13-hotspot]', gal).forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      });

      /* follow the variant picker */
      document.addEventListener('c13:variant:change', function (e) {
        var mid = e.detail && e.detail.mediaId;
        if (!mid) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mid)) { show(i, false); break; }
        }
      });

      show(0, false);
    });
  }

  /* Point the "Ask a question" trigger at the right enquiry reason */
  function initEnquiry() {
    var field = $('[data-c13-enquiry-reason-field]');
    if (!field) return;
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-c13-modal-open="enquiry"]') : null;
      if (!t) return;
      field.value = t.getAttribute('data-c13-enquiry-reason') === 'question'
        ? 'Question about an edition'
        : 'Edition purchase enquiry';
    });
  }

  function boot() { initGallery(); initEnquiry(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }

  document.addEventListener('shopify:section:load', function () {
    $$('[data-c13-gallery2]').forEach(function (g) { delete g.dataset.c13Bound; });
    boot();
  });
})();
